import script from "./QuestionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionPage.vue?vue&type=script&setup=true&lang=js"

import "./QuestionPage.vue?vue&type=style&index=0&id=60420bcd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60420bcd"]])

export default __exports__